import React from 'react'
import styles from './style.module.css'
const DigitalCard = ({name, desc , img}) => {
  return (
    <div className={styles.box}>
    <div className={styles.left}>
      <h5>{name}</h5>
      <p>{desc}</p>
    </div>
    <div className={styles.right}>
      <div className={styles.iconContainer}>
        <img src={img} alt="ICON"/>
        <p>{name}</p>
      </div>
    </div>
  </div>
  )
}

export default DigitalCard
